export const fuseNavigationConfig = [
  /*{
    'id': 'dashboard',
    'title': 'Dashboard',
    'type': 'group',
    'children': [
      {
        'id': 'dashboard',
        'title': 'Dashboard',
        'type': 'item',
        'icon': 'dashboard',
        'url': '/dashboard'
      }
    ]
  }, */
  {
    'id': 'tasks_amministrazione',
    'title': 'Emissione',
    'type': 'group',
    'auth': ['admin'],
    'children': [
      {
        'id': 'nuova_produzione',
        'title': 'Nuova Produzione',
        'type': 'item',
        'icon': 'group_add',
        'url': '/tasks/nuovaProduzione',
        'auth': ['admin', 'inbound', 'sales_emissione', 'sales_rinnovi_emissione']
      },
      {
        'id': 'lista_nuova_produzione',
        'title': 'Lista Nuova Produzione',
        'type': 'item',
        'icon': 'group_add',
        'url': '/tasks/lista/nuovaProduzione',
        'auth': ['admin','inbound', 'sales_emissione', 'sales_rinnovi_emissione']
      },
      {
        'id': 'rinnovi',
        'title': 'Rinnovi',
        'type': 'item',
        'icon': '360',
        'url': '/tasks/rinnovi',
        'auth': ['admin','inbound', 'rinnovi_emissione', 'sales_rinnovi_emissione']
      },
      {
        'id': 'scadenze',
        'title': 'Scadenze',
        'type': 'item',
        'icon': 'access_alarm',
        'url': '/tasks/scadenze',
        'auth': ['admin','inbound', 'rinnovi_emissione', 'sales_rinnovi_emissione']
      }
    ]
  },
  {
    'id': 'mioassicuratore',
    'title': 'Contabilità',
    'type': 'group',
    'auth': ['admin'],
    'children': [
      {
        'id': 'contabilita_mioassicuratore',
        'title': 'Contabilità Mioassicuratore',
        'type': 'item',
        'icon': 'credit_card',
        'url': '/contabilita/mioassicuratore',
        'auth': ['admin']
      },
      {
        'id': 'controllo_fatture',
        'title': 'Controllo Fatture',
        'type': 'item',
        'icon': 'money',
        'url': '/contabilita/controllo-fatture',
        'auth': ['admin']
      },
      {
        'id': 'contabilita_broker',
        'title': 'Contabilità Broker',
        'type': 'item',
        'icon': 'credit_card',
        'url': '/contabilita/broker',
        'auth': ['admin']
      },
      {
        'id': 'chiusure_broker',
        'title': 'Contabilità Broker Dashboard',
        'type': 'item',
        'icon': 'dashboard',
        'url': '/chiusure/broker',
        'auth': ['admin']
      },
      {
        'id': 'compagnie_broker',
        'title': 'Contabilità Compagnie Dashboard',
        'type': 'item',
        'icon': 'dashboard',
        'url': '/compagnie/broker',
        'auth': ['admin']
      },
      {
        'id': 'percentuali_stipendi',
        'title': 'Definizione Percentuali Stipendi',
        'type': 'item',
        'icon': 'money',
        'url': '/percentuali_stipendi',
        'auth': ['admin']
      },
      {
        'id': 'stipendi',
        'title': 'Stipendi',
        'type': 'item',
        'icon': 'money',
        'url': '/stipendi',
        'auth': ['admin'],
      }
    ]
  },
  {
    'id': 'ricerca',
    'title': 'Ricerca',
    'type': 'group',
    'auth': ['admin', 'inbound', 'sales', 'sales_external', 'sales_emissione', 'rinnovi', 'rinnovi_emissione', 'sales_rinnovi_emissione'],
    'children': [
      {
        'id': 'utenti',
        'title': 'Utenti',
        'type': 'item',
        'icon': 'people',
        'url': '/utenti',
        'auth': ['admin', 'inbound', 'sales', 'sales_external', 'sales_emissione', 'rinnovi', 'rinnovi_emissione', 'sales_rinnovi_emissione']
      },
      {
        'id': 'quotazioni',
        'title': 'Quotazioni',
        'type': 'item',
        'icon': 'assessment',
        'url': '/quotazione',
        'auth': ['admin', 'inbound', 'sales_emissione', 'rinnovi_emissione', 'sales_rinnovi_emissione']
      },
      {
        'id': 'sinistri',
        'title': 'Sinistri',
        'type': 'item',
        'icon': 'money_off',
        'url': '/sinistri',
        'auth': ['admin']
      },
      {
        'id': 'polizze',
        'title': 'Polizze',
        'type': 'item',
        'icon': 'assessment',
        'url': '/polizze',
        'auth': ['admin', 'inbound', 'sales_emissione', 'rinnovi_emissione', 'sales_rinnovi_emissione']
      }
    ]
  },
  {
    'id': 'gestione',
    'title': 'Gestione',
    'type': 'group',
    'auth': ['admin', 'inbound', 'sales', 'sales_external', 'sales_emissione', 'rinnovi', 'rinnovi_emissione', 'sales_rinnovi_emissione'],
    'children': [
      {
        'id': 'storico_stipendi',
        'title': 'Storico Stipendi',
        'type': 'item',
        'icon': 'history',
        'url': 'storico_stipendi'
      },
      {
        'id': 'dashboardOps',
        'title': 'Dashboard',
        'type': 'item',
        'icon': 'dashboard',
        'url': '/dashboardOps'
      },
      {
        'id': 'calendar',
        'title': 'Calendario',
        'type': 'item',
        'icon': 'calendar_today',
        'url': '/calendar',
        'auth': ['admin', 'inbound', 'sales', 'sales_external', 'sales_emissione', 'sales_rinnovi_emissione']
      },
      {
        'id': 'gestione_leads',
        'title': 'Gestione Leads',
        'type': 'item',
        'icon': 'call',
        'url': '/commerciali/gestione',
        'auth': ['admin', 'inbound', 'sales', 'sales_external', 'sales_emissione', 'sales_rinnovi_emissione']
      },
      {
        'id': 'gestione_rinnovi',
        'title': 'Gestione Rinnovi',
        'type': 'item',
        'icon': '360',
        'url': '/commerciali/rinnovi',
        'auth': ['admin', 'inbound', 'rinnovi', 'rinnovi_emissione', 'sales_rinnovi_emissione']
      },
      {
        'id': 'gestione_assistenza_clienti',
        'title': 'Gestione Assistenza Clienti',
        'type': 'item',
        'icon': '360',
        'url': '/commerciali/assistenzaClienti',
        'auth': ['admin', 'inbound', 'sales', 'sales_emissione', 'rinnovi', 'rinnovi_emissione', 'sales_rinnovi_emissione']
      },
      {
        'id': 'sinistri',
        'title': 'Elenco Sinistri',
        'type': 'item',
        'icon': 'money_off',
        'url': '/sinistri',
        'auth': ['admin']
      },
      {
        'id': 'in_emissione',
        'title': 'Quotazioni In Emissione',
        'type': 'item',
        'icon': 'exit_to_app',
        'url': '/in-emissione',
        'auth': ['admin']
      },
      {
        'id': 'controllo_gestione',
        'title': 'Polizze senza documento',
        'type': 'item',
        'icon': 'computer',
        'url': '/amministrazione/controllo',
        'auth': ['admin']
      },
      {
        'id': 'documenti_da_validare',
        'title': 'Documenti da validare',
        'type': 'item',
        'icon': 'document_scanner',
        'url': '/amministrazione/documenti',
        'auth': ['admin', 'inbound', 'sales', 'sales_emissione', 'rinnovi', 'rinnovi_emissione', 'sales_rinnovi_emissione']
      },
      {
        'id': 'assegnazione_skill',
        'title': 'Assegnazione Skill',
        'type': 'item',
        'icon': 'assignment',
        'url': '/assegnazione_skill',
        'auth': ['admin']
      }
    ]
  },
  {
    'id': 'anagrafiche',
    'title': 'Mandatari',
    'type': 'group',
    'auth': ['admin', 'inbound', 'sales', 'sales_emissione', 'rinnovi', 'rinnovi_emissione', 'sales_rinnovi_emissione'],
    'children': [
      {
        'id': 'mandatari',
        'title': 'Anagrafiche Mandatari',
        'type': 'item',
        'icon': 'face',
        'url': '/anagrafiche/mandatari'
      },
      {
        'id': 'backend_entita',
        'title': 'Backend Entita',
        'type': 'item',
        'icon': 'face',
        'url': '/anagrafiche/backendEntita',
        'auth': ['admin']
      }
    ]
  },
  /* {
    'id': 'richieste',
    'title': 'Richieste',
    'type': 'group',
    'children': [
      {
        'id': 'richieste',
        'title': 'Richieste',
        'type': 'item',
        'icon': 'assessment',
        'url': '/richiesta'
      }
    ]
  }, */
  {
    'id': 'logs',
    'title': 'Logs',
    'type': 'group',
    'auth': ['admin'],
    'children': [
      {
        'id': 'logs_stripe',
        'title': 'Stripe',
        'type': 'item',
        'icon': 'assessment',
        'url': '/logs/stripe',
        'auth': ['admin']
      },
      {
        'id': 'logs_crm',
        'title': 'Crm',
        'type': 'item',
        'icon': 'security',
        'url': '/logs/crm',
        'auth': ['admin']
      }
    ]
  },
  {
    'id': 'faqs',
    'title': 'Faqs',
    'type': 'group',
    'auth': ['admin'],
    'children': [
      {
        'id': 'faqs',
        'title': 'Faqs',
        'type': 'item',
        'icon': 'question_answer',
        'url': '/faqs',
        'auth': ['admin']
      }
    ]
  },
  {
    'id': 'utm',
    'title': 'UTM',
    'type': 'group',
    'auth': ['admin'],
    'children': [
      {
        'id': 'utm_builder',
        'title': 'UTM Builder',
        'type': 'item',
        'icon': 'compass_calibration',
        'url': '/utm/builder'
      },
      {
        'id': 'gestione_utm',
        'title': 'Gestione Utm',
        'type': 'item',
        'icon': 'compass_calibration',
        'url': '/utm/gestione'
      }
    ]
  },
  {
    'id': 'stats',
    'title': 'Statistiche',
    'type': 'group',
    'children': [
      {
        'id': 'incassi',
        'title': 'Incassi',
        'type': 'item',
        'icon': 'input',
        'url': '/statistiche/incassi'
      },
      {
        'id': 'disassegnate',
        'title': 'Disassegnate',
        'type': 'item',
        'icon': 'input',
        'url': '/statistiche/disassegnate'
      },
      {
        'id': 'autorizzazioni',
        'title': 'Autorizzazioni',
        'type': 'item',
        'icon': 'account_balance',
        'url': '/statistiche/autorizzazioni',
        'auth': ['admin']
      },
      {
        'id': 'frazionamenti',
        'title': 'Frazionamenti',
        'type': 'item',
        'icon': 'layers',
        'url': '/statistiche/frazionamenti',
        'auth': ['admin']
      },
      {
        'id': 'marketing',
        'title': 'Marketing Richieste',
        'type': 'item',
        'icon': 'bar_chart',
        'url': '/statistiche/marketing',
        'auth': ['admin']
      },
      {
        'id': 'new_business',
        'title': 'New Business Richieste',
        'type': 'item',
        'icon': 'attach_money',
        'url': '/statistiche/new_business',
        'auth': ['admin']
      },
      {
        'id': 'rinnoviNew',
        'title': 'Rinnovi',
        'type': 'item',
        'icon': '360',
        'url': '/statistiche/rinnoviNew',
        'auth': ['admin']
      },
      /* {
        'id': 'richieste_uniche',
        'title': 'Richieste Uniche',
        'type': 'item',
        'icon': 'filter_1',
        'url': '/statistiche/richiesteUniche'
      } */
      {
        'id': 'utenti',
        'title': 'Utenti',
        'type': 'item',
        'icon': 'supervisor_account',
        'url': '/statistiche/utenti',
        'auth': ['admin']
      },
      {
        'id': 'scadenze',
        'title': 'Scadenze',
        'type': 'item',
        'icon': 'alarm_on',
        'url': '/statistiche/scadenze',
        'auth': ['admin']
      },
      {
        'id': 'polizze_esterne',
        'title': 'Polizze Esterne',
        'type': 'item',
        'icon': 'alarm_on',
        'url': '/statistiche/polizze_esterne',
        'auth': ['admin']
      },
      {
        'id': 'relazioni',
        'title': 'Relazioni',
        'type': 'item',
        'icon': 'category',
        'url': '/statistiche/relazioni',
        'auth': ['admin']
      },
      {
        'id': 'recall',
        'title': 'Recall',
        'type': 'item',
        'icon': 'call',
        'url': '/statistiche/recall'
      },
      {
        id: 'appuntamenti',
        title: 'Appuntamenti Consulenze Questionari',
        type: 'item',
        icon: 'book_online',
        url: '/statistiche/appuntamenti_questionari',
        auth: ['admin']
      },
      {
        'id': 'utm',
        'title': 'Utm',
        'type': 'item',
        'icon': 'compass_calibration',
        'url': '/statistiche/utm',
        'auth': ['admin']
      },
      {
        'id': 'operatori',
        'title': 'Gestione Operatori',
        'type': 'item',
        'icon': 'computer',
        'url': '/statistiche/operatori',
        'auth': ['admin']
      },
      {
        'id': 'analisi_gestione',
        'title': 'Analisi Gestione',
        'type': 'item',
        'icon': 'computer',
        'url': '/statistiche/analisi',
        'auth': ['admin']
      }
    ]
  },
  {
    'id': 'logout',
    'title': 'Log Out',
    'type': 'group',
    'children': [
      {
        'id': 'logout',
        'title': 'Log Out',
        'type': 'item',
        'icon': 'exit_to_app',
        'url': '/logout'
      }
    ]
  }
]
